// GTJ DUPLICATE FAST RETURN SAFETY V2_1
// GTJ COMPACT DASHBOARD SUCCESS V4
// GTJ PAYMENT STATUS CLEANUP V2
// GTJ HIDE MANUAL PAYMENT STATUS V1
import React, { useEffect, useRef, useState } from "react";
import "./GlobalJobsApplications.css";
import "./GlobalJobsWizard.css";

// GTJ UNIFIED APPLICATION WIZARD V1
const STORAGE_KEY = 'gtj_candidate_session_v1';
const API = "/api/global-tech-jobs";
const MAX_FILE = 5 * 1024 * 1024;
const CHECKOUT_ENABLED =
  process.env.REACT_APP_GTJ_CHECKOUT_ENABLED === "true";
const APPLICATIONS_ENABLED =
  process.env.REACT_APP_GTJ_APPLICATIONS_ENABLED === "true";

function tokenNow() {
  try { return sessionStorage.getItem(STORAGE_KEY) || ""; }
  catch { return ""; }
}

function shortId(value) {
  const str = String(value || "");
  let hash = 2166136261;
  for (let i = 0; i < str.length; i++) {
    hash ^= str.charCodeAt(i);
    hash = Math.imul(hash, 16777619);
  }
  return String((hash >>> 0) % 10000).padStart(4, "0");
}

async function api(path, token = "", options = {}) {
  const headers = {
    ...(options.body instanceof FormData
      ? {}
      : options.body ? {"Content-Type": "application/json"} : {}),
    ...(token ? {Authorization: `Bearer ${token}`} : {}),
  };
  let response;
  try {
    response = await fetch(`${API}/${path}`, {
      ...options,
      headers: {...headers, ...(options.headers || {})}
    });
  } catch {
    throw new Error("Unable to connect. Check your internet and try again.");
  }
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    const detail = data.detail;
    throw new Error(
      typeof detail === "string"
        ? detail
        : `Request failed (${response.status}).`
    );
  }
  return data;
}

function splitName(name) {
  const parts = String(name || "").trim().split(/\s+/).filter(Boolean);
  return {
    first: parts[0] || "",
    last: parts.slice(1).join(" ")
  };
}


// Load the official Razorpay Checkout script on demand.
function loadRazorpayCheckout() {
  return new Promise((resolve, reject) => {
    if (window.Razorpay) {
      resolve();
      return;
    }

    const existing = document.querySelector(
      'script[data-gtj-razorpay="true"]'
    );

    if (existing) {
      existing.addEventListener("load", resolve, {once:true});
      existing.addEventListener(
        "error",
        () => reject(new Error("Payment service could not load.")),
        {once:true}
      );
      return;
    }

    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.async = true;
    script.dataset.gtjRazorpay = "true";
    script.onload = resolve;
    script.onerror = () =>
      reject(new Error("Payment service could not load."));
    document.body.appendChild(script);
  });
}

// GTJ WIZARD UI POLISH V1

// GTJ WIZARD VISUAL POLISH V2

function WizardStepIcon({index}) {
  const paths = [
    <><rect x="3" y="5" width="18" height="14" rx="2"/>
       <path d="m3 7 9 6 9-6"/></>,
    <><path d="M7 3h7l5 5v13H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z"/>
       <path d="M14 3v6h5M9 13h6M9 17h6"/></>,
    <><rect x="3" y="4" width="18" height="16" rx="2"/>
       <circle cx="9" cy="10" r="2"/>
       <path d="M6 16c.5-2 5.5-2 6 0M15 9h4M15 13h4M15 17h3"/></>,
    <><rect x="2" y="5" width="20" height="14" rx="3"/>
       <path d="M2 10h20M6 15h5"/></>,
    <><circle cx="12" cy="12" r="9"/>
       <path d="m8 12 3 3 5-6"/></>
  ];

  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {paths[index]}
    </svg>
  );
}

const GTJW_REGION_NAMES =
  typeof Intl !== "undefined" && Intl.DisplayNames
    ? new Intl.DisplayNames(["en"], {type:"region"})
    : null;

function wizardCountryCode(job) {
  const existing = String(
    job.country_code || job.countryCode || ""
  ).trim().toUpperCase();

  if (/^[A-Z]{2}$/.test(existing)) return existing;

  const name = String(job.country || "").trim();

  const aliases = {
    "UNITED STATES":"US",
    "UNITED STATES OF AMERICA":"US",
    "USA":"US",
    "UK":"GB",
    "UNITED KINGDOM":"GB",
    "SOUTH KOREA":"KR",
    "INDIA":"IN",
    "FRANCE":"FR",
    "GERMANY":"DE",
    "CANADA":"CA",
    "AUSTRALIA":"AU",
    "JAPAN":"JP",
    "BRAZIL":"BR"
  };

  if (aliases[name.toUpperCase()]) {
    return aliases[name.toUpperCase()];
  }

  if (/^[A-Za-z]{2}$/.test(name)) {
    return name.toUpperCase();
  }

  if (GTJW_REGION_NAMES) {
    for (let a = 65; a <= 90; a++) {
      for (let b = 65; b <= 90; b++) {
        const code = String.fromCharCode(a,b);
        if (
          GTJW_REGION_NAMES.of(code).toLowerCase() ===
          name.toLowerCase()
        ) {
          return code;
        }
      }
    }
  }

  return "";
}

// GTJ REMOVE COUNTRY SKILLS V1

// GTJ APPLICATION SUCCESS AUTO RETURN V1

// GTJ SMOOTH APPLICATION SUCCESS V3
function GTJApplicationAutoReturn({ onClose }) {
  useEffect(() => {
    const target = document.querySelector(".gtjw-smooth-position");
    if (!target) return;

    const modal = target.closest('[role="dialog"], .gtjw-modal, .gtjw-overlay');
    const scrollable = modal
      ? [modal, ...modal.querySelectorAll("*")].find(
          el => el.scrollHeight > el.clientHeight + 20 &&
          getComputedStyle(el).overflowY !== "visible"
        )
      : null;

    if (scrollable) {
      scrollable.scrollTo({ top: scrollable.scrollHeight, behavior: "smooth" });
    } else {
      target.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }, []);


  const [seconds, setSeconds] = useState(5);

  useEffect(() => {
    const timer = setInterval(() => {
      setSeconds(value => Math.max(0, value - 1));
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    if (seconds === 0) onClose();
  }, [seconds, onClose]);

  return (
    <div className={
      "gtjw-smooth-return" +
      (seconds <= 1 ? " gtjw-smooth-exit" : "")
    }>
      <div className="gtjw-smooth-count" aria-live="off">
        {seconds}
      </div>
      <strong>Returning to job listings</strong>
      <p>Your application is safely submitted.</p>
      <div className="gtjw-smooth-progress">
        <div />
      </div>
    </div>
  );
}

export default function GlobalJobsApplicationFlow({job, onClose}) {
  const [token, setToken] = useState(tokenNow);
  const [stage, setStage] = useState(tokenNow() ? 1 : 0);
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [sent, setSent] = useState(false);
  const [resume, setResume] = useState(null);
  const [details, setDetails] = useState({
    first:"",last:"",phone:"",
  });
  const [profile, setProfile] = useState({});
  const [membership, setMembership] = useState(null);
  const [application, setApplication] = useState(null);
  // GTJ WIZARD RAZORPAY AUTO APPLY V2
  const submissionLock = useRef(false);
  const [paymentState, setPaymentState] = useState("");
  const [paymentReference, setPaymentReference] = useState("");
  const [checkoutOpen, setCheckoutOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [notice, setNotice] = useState("");

  const steps = ["Verify Email","Resume","Your Details","₹49 Membership","Success"];


  // GTJ SAVED RESUME WIZARD V2B
  const [savedResume, setSavedResume] = useState(null);
  const [savedResumeBusy, setSavedResumeBusy] = useState(false);
  const [savedResumeError, setSavedResumeError] = useState("");

  useEffect(() => {
    if (!token) {
      setSavedResume(null);
      return;
    }

    let cancelled = false;

    const loadSavedResume = async () => {
      try {
        const response = await fetch(
          "/api/global-tech-jobs/applications/resume/latest/metadata",
          {
            headers: {
              Authorization: `Bearer ${token}`
            },
            cache: "no-store"
          }
        );

        if (response.status === 404) {
          if (!cancelled) setSavedResume(null);
          return;
        }

        if (!response.ok) {
          throw new Error("Could not load saved resume information.");
        }

        const result = await response.json();

        if (!cancelled) {
          setSavedResume(result.available ? result : null);
          setSavedResumeError("");
        }
      } catch (err) {
        if (!cancelled) {
          setSavedResume(null);
          setSavedResumeError(err.message);
        }
      }
    };

    loadSavedResume();

    return () => {
      cancelled = true;
    };
  }, [token]);

  async function fetchSavedResumePdf() {
    if (!token) throw new Error("Please verify your email.");

    const response = await fetch(
      "/api/global-tech-jobs/applications/resume/latest",
      {
        headers: {
          Authorization: `Bearer ${token}`
        },
        cache: "no-store"
      }
    );

    if (!response.ok) {
      throw new Error(
        "Saved resume is unavailable. Please upload a new PDF."
      );
    }

    const blob = await response.blob();

    if (
      blob.size === 0 ||
      blob.size > 5 * 1024 * 1024
    ) {
      throw new Error("Saved resume does not meet the 5 MB limit.");
    }

    return blob;
  }

  async function useSavedResume() {
    if (savedResumeBusy) return;

    setSavedResumeBusy(true);
    setSavedResumeError("");

    try {
      const blob = await fetchSavedResumePdf();

      const filename =
        String(savedResume?.filename || "saved-resume.pdf")
          .replace(/[^\w.\- ]/g, "_")
          .slice(0, 120);

      const safeName = filename.toLowerCase().endsWith(".pdf")
        ? filename
        : "saved-resume.pdf";

      const file = new File(
        [blob],
        safeName,
        { type: "application/pdf" }
      );

      setResume(file);
      setError("");
      setStage(2);
    } catch (err) {
      setSavedResumeError(err.message);
    } finally {
      setSavedResumeBusy(false);
    }
  }

  async function downloadSavedResume() {
    if (savedResumeBusy) return;

    setSavedResumeBusy(true);
    setSavedResumeError("");

    try {
      const blob = await fetchSavedResumePdf();
      const link = document.createElement("a");
      const url = URL.createObjectURL(blob);

      link.href = url;
      link.download = "saved-resume.pdf";
      document.body.appendChild(link);
      link.click();
      link.remove();

      setTimeout(() => URL.revokeObjectURL(url), 1000);
    } catch (err) {
      setSavedResumeError(err.message);
    } finally {
      setSavedResumeBusy(false);
    }
  }

  useEffect(() => {
    if (!token) return;
    let cancelled = false;
    Promise.all([
      api("candidate/profile", token),
      api("membership/status", token)
    ]).then(([profileData, membershipData]) => {
      if (cancelled) return;
      const p = profileData.profile || {};
      const name = splitName(p.full_name);
      setProfile(p);
      setDetails({
        first:name.first,
        last:name.last,
        phone:p.phone || "",
        country:p.country || "",
        skills:Array.isArray(p.skills) ? p.skills.join(", ") : (p.skills || "")
      });
      setMembership(membershipData);
    }).catch(err => {
      if (!cancelled) setNotice(err.message);
    });
    return () => { cancelled = true; };
  }, [token]);

  async function execute(task) {
    setBusy(true);
    setError("");
    try { await task(); }
    catch (err) { setError(err.message || "Something went wrong."); }
    finally { setBusy(false); }
  }

  function sendOtp(e) {
    e.preventDefault();
    execute(async () => {
      await api("auth/request-otp", "", {
        method:"POST",
        body:JSON.stringify({email:email.trim().toLowerCase()})
      });
      setSent(true);
      setNotice("We sent a 6-digit code to your email.");
    });
  }

  function verifyOtp(e) {
    e.preventDefault();
    execute(async () => {
      const result = await api("auth/verify-otp", "", {
        method:"POST",
        body:JSON.stringify({
          email:email.trim().toLowerCase(),
          otp:otp.trim()
        })
      });
      if (!result.access_token) throw new Error("Login confirmation is missing.");
      sessionStorage.setItem(STORAGE_KEY, result.access_token);
      setToken(result.access_token);
      window.dispatchEvent(new Event("gtj-wizard-login"));
      window.dispatchEvent(new Event("gtj-candidate-authenticated"));
      setStage(1);
      setNotice("");
    });
  }


  // GTJ DUPLICATE APPLICATION FAST RETURN V2
  const [duplicateApplication, setDuplicateApplication] = useState(null);
  const [checkingDuplicate, setCheckingDuplicate] = useState(false);

  useEffect(() => {
    if (!token || (!job?.job_id && !job?.id)) {
      setDuplicateApplication(null);
      return;
    }

    let cancelled = false;
    const selectedId = String(job.job_id || job.id);

    setDuplicateApplication(null);
    setCheckingDuplicate(true);

    async function checkPreviousApplication() {
      try {
        for (let page = 1; page <= 500; page++) {
          const data = await api(
            `applications/me?page=${page}&page_size=20`,
            token
          );

          if (cancelled) return;

          const items = Array.isArray(data.items)
            ? data.items
            : Array.isArray(data.applications)
              ? data.applications
              : [];

          const existing = items.find(
            item => String(item.job_id) === selectedId
          );

          if (existing) {
            setDuplicateApplication(existing);
            setStage(4);
            return;
          }

          if (items.length < 20) break;
        }
      } catch (err) {
        console.warn(
          "Existing application check failed:",
          err.message
        );
      } finally {
        if (!cancelled) setCheckingDuplicate(false);
      }
    }

    checkPreviousApplication();

    return () => {
      cancelled = true;
    };
  }, [token, job?.job_id, job?.id]);

  function nextResume(e) {
    if (checkingDuplicate || duplicateApplication) {
      e.preventDefault();
      return;
    }
    e.preventDefault();
    if (!resume || !resume.name.toLowerCase().endsWith(".pdf")) {
      setError("Please choose a PDF resume.");
      return;
    }
    if (resume.size === 0 || resume.size > MAX_FILE) {
      setError("Your PDF must be between 1 byte and 5 MB.");
      return;
    }
    setError("");
    setStage(2);
  }

  function saveDetails(e) {
    e.preventDefault();
    execute(async () => {
      if (!details.first.trim() || !details.last.trim()) {
        throw new Error("Enter your first and last name.");
      }
      if (!/^[+0-9()\s-]{7,20}$/.test(details.phone.trim())) {
        throw new Error("Enter a valid mobile number.");
      }


      const payload = {
        ...profile,
        full_name: `${details.first.trim()} ${details.last.trim()}`,
        phone:details.phone.trim(),
        // Preserve existing candidate profile fields.
        // Do not invent country or skills.

      };

      await api("candidate/profile", token, {
        method: 'PUT',
        body:JSON.stringify(payload)
      });
      setProfile(payload);
      const result = await api("membership/status", token);
      setMembership(result);
      setStage(3);
    });
  }


  // Only a verified active membership allows an application.
  // Payment success alone is never treated as membership activation.
  async function submitVerifiedApplication(activeMembership) {
    if (checkingDuplicate || duplicateApplication) {
      throw new Error(
        "An existing application check is in progress or " +
        "you have already applied for this job."
      );
    }

    if (!APPLICATIONS_ENABLED) {
      throw new Error(
        "Job applications are not available yet. No application was submitted."
      );
    }

    if (!activeMembership?.active) {
      throw new Error("Membership verification is required.");
    }

    if (!resume) {
      throw new Error("Please attach your PDF resume.");
    }

    if (submissionLock.current) return;

    submissionLock.current = true;
    setBusy(true);
    setPaymentState("submitting");
    setError("");

    try {
      const form = new FormData();
      form.append("job_id", job.job_id || job.id);
      form.append("resume", resume);

      const result = await api("applications", token, {
        method: "POST",
        body: form
      });

      if (!result.application?.application_id) {
        throw new Error(
          "Application confirmation is missing. Check My Job Dashboard before retrying."
        );
      }

      setApplication(result.application);
      setStage(4);
      setPaymentState("completed");

      // Refresh membership and dashboard after confirmed submission.
      window.dispatchEvent(
        new Event("gtj-membership-updated")
      );

      window.dispatchEvent(
        new Event("gtj-applications-changed")
      );
    } catch (err) {
      setPaymentState("application-error");
      setError(err.message || "Application submission failed.");
    } finally {
      submissionLock.current = false;
      setBusy(false);
    }
  }

  async function beginMembershipPayment() {
    if (busy || checkoutOpen || membership?.active) return;

    // Do not accept payments while applications cannot be completed.
    if (!CHECKOUT_ENABLED || !APPLICATIONS_ENABLED) {
      setError(
        "Online applications and membership payments are opening soon."
      );
      return;
    }

    setBusy(true);
    setError("");
    setNotice("");
    setPaymentState("preparing");

    try {
      // Load checkout first, before generating an order.
      await loadRazorpayCheckout();

      const order = await api("membership/create-order", token, {
        method: "POST"
      });

      if (order.already_paid || order.membership?.active) {
        const status = await api("membership/status", token);
        setMembership(status);
        setPaymentState(status.active ? "verified" : "");

        if (status.active) {
          await submitVerifiedApplication(status);
        }
        return;
      }

      const orderId = order.order_id || order.razorpay_order_id;
      const keyId = order.key_id || order.razorpay_key_id;
      const amount = Number(order.amount);
      const currency = order.currency || "INR";

      if (!orderId || !keyId || !Number.isInteger(amount)) {
        throw new Error("Payment order details are incomplete.");
      }

      // ₹49 = 4900 paise.
      // Fail safely if the backend returns a different charge.
      if (amount !== 4900 || currency !== "INR") {
        throw new Error(
          "Payment amount does not match ₹49. No payment was opened."
        );
      }

      setCheckoutOpen(true);
      setPaymentState("checkout");

      const checkout = new window.Razorpay({
        key: keyId,
        amount,
        currency,
        order_id: orderId,
        name: "SnehAchievers Tech AI",
        description: "Annual Job Platform Membership",
        prefill: {
          name: details.first + " " + details.last,
          contact: details.phone
        },
        theme: {
          color: "#087e72"
        },
        modal: {
          ondismiss: () => {
            setCheckoutOpen(false);
            setPaymentState("");
            setNotice(
              "Payment window closed. You can continue when ready."
            );
          }
        },
        handler: async (payment) => {
          setCheckoutOpen(false);
          setBusy(true);
          setPaymentState("verifying");
          setError("");

          try {
            if (
              !payment.razorpay_order_id ||
              !payment.razorpay_payment_id ||
              !payment.razorpay_signature
            ) {
              throw new Error(
                "Payment confirmation was incomplete."
              );
            }

            setPaymentReference(payment.razorpay_order_id);

            const verification = await api(
              "membership/verify",
              token,
              {
                method: "POST",
                body: JSON.stringify({
                  razorpay_order_id:
                    payment.razorpay_order_id,
                  razorpay_payment_id:
                    payment.razorpay_payment_id,
                  razorpay_signature:
                    payment.razorpay_signature
                })
              }
            );

            const status =
              verification.membership?.active
                ? verification.membership
                : await api("membership/status", token);

            setMembership(status);

            if (!status.active) {
              throw new Error(
                "Your payment requires confirmation. " +
                "Please check membership status. Do not pay again."
              );
            }

            setPaymentState("verified");
            setNotice("Membership verified successfully.");

            // GTJ WIZARD PAYMENT SAFETY V3
            // Payment is verified; application submission now
            // runs through its own protected operation.
            setBusy(false);
            await submitVerifiedApplication(status);

          } catch (err) {
            setPaymentState("verification-error");
            setError(
              (err.message || "Payment verification failed.") +
              " If money was deducted, use Check Payment Status."
            );
          } finally {
            setBusy(false);
          }
        }
      });

      checkout.on("payment.failed", () => {
        setCheckoutOpen(false);
        setPaymentState("payment-failed");
        setError(
          "Payment did not complete. If money was deducted, " +
          "check your membership status before paying again."
        );
      });

      checkout.open();

    } catch (err) {
      setCheckoutOpen(false);
      setPaymentState("");
      setError(err.message || "Unable to open payment.");
    } finally {
      setBusy(false);
    }
  }


  // GTJ ACTIVE MEMBER AUTO SUBMIT V2
  const gtjAutoSubmitAttempted = useRef(false);
  const gtjSubmitRef = useRef(submitVerifiedApplication);

  gtjSubmitRef.current = submitVerifiedApplication;

  useEffect(() => {
    if (stage !== 3) return;
    if (!membership?.active) return;
    if (application || duplicateApplication || checkingDuplicate) return;
    if (gtjAutoSubmitAttempted.current) return;

    gtjAutoSubmitAttempted.current = true;

    gtjSubmitRef.current(membership);
  }, [stage, membership, application, duplicateApplication, checkingDuplicate]);

  async function finishExistingMembership() {
    if (busy || submissionLock.current) return;

    setBusy(true);
    setError("");

    try {
      const status = await api("membership/status", token);
      setMembership(status);

      if (!status.active) {
        throw new Error(
          "An active membership is required."
        );
      }

      await submitVerifiedApplication(status);

    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="gtjw-overlay" role="presentation">
      <section className="gtjw-modal" role="dialog"
        aria-modal="true" aria-label="Job application wizard">
        <header className="gtjw-head">
          <div>
            <small>GLOBAL TECH JOBS</small>
            <h2>Apply for {job.title}</h2>
            
            <div className="gtjw-job-meta">
              <span className="gtjw-company-name">
                {job.company}
              </span>

              <span className="gtjw-country-badge">
                {wizardCountryCode(job) && (
                  <img
                    src={`https://flagcdn.com/w80/${wizardCountryCode(job).toLowerCase()}.png`}
                    alt=""
                    width="28"
                    height="19"
                    loading="lazy"
                  />
                )}
                <strong>{job.country}</strong>
              </span>

              <span className="gtjw-job-id">
                Job #{shortId(job.job_id || job.id)}
              </span>
            </div>
          </div>
          <button type="button" onClick={onClose} aria-label="Close"
            disabled={busy} className="gtjw-close">×</button>
        </header>

        <div className="gtjw-steps">
          {steps.map((s,i) => (
            <div key={s} className={"gtjw-step " +
              (i===stage ? "current" : i<stage ? "done" : "")}>
              <div className="gtjw-step-art">
                <WizardStepIcon index={i}/>
              </div>
              <span>{i<stage ? "✓" : i+1}</span>
              <small>{s}</small>
            </div>
          ))}
        </div>

        <div className="gtjw-body">
          {stage===0 && (
            <>
              <h3>{sent ? "Enter your verification code" : "Verify your email"}</h3>
              <p className="gtjw-sub">We use your email to securely manage your job applications.</p>
              {!sent ? (
                <form onSubmit={sendOtp} className="gtjw-form">
                  <label className="gtjw-email-label">Enter your email address
                    <input type="email" required value={email}
                      onChange={e=>setEmail(e.target.value)}
                      placeholder="e.g. yourname@gmail.com"/>
                  </label>
                  <button disabled={busy} type="submit">
                    {busy ? "Sending..." : "Send Verification Code"}
                  </button>
                </form>
              ) : (
                <form onSubmit={verifyOtp} className="gtjw-form">
                  <label>6-digit verification code
                    <input inputMode="numeric" maxLength={6}
                      minLength={6} required value={otp}
                      onChange={e=>setOtp(e.target.value.replace(/\D/g,""))}
                      placeholder="Enter 6-digit code"/>
                  </label>
                  <button disabled={busy || otp.length!==6} type="submit">
                    {busy ? "Verifying..." : "Verify & Continue"}
                  </button>
                  <button type="button" className="gtjw-secondary"
                    onClick={()=>{setSent(false);setOtp("");setNotice("");}}>
                    Change email
                  </button>
                </form>
              )}
            </>
          )}

          {stage===1 && (
            <>
              <h3>Upload your resume</h3>
              <p className="gtjw-sub">Choose your latest resume in PDF format, maximum 5 MB.</p>
              
          {savedResume && (
            <section className="gtjw-saved-resume">
              <div className="gtjw-saved-resume-header">
                <span className="gtjw-saved-resume-icon" aria-hidden="true">
                  <svg viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" strokeWidth="1.8"
                    strokeLinecap="round" strokeLinejoin="round">
                    <path d="M7 3h7l5 5v13H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z"/>
                    <path d="M14 3v6h5M9 13h6M9 17h6"/>
                  </svg>
                </span>
                <div>
                  <h4>Your saved resume is ready</h4>
                  <p>{savedResume.filename || "Previously uploaded PDF"}</p>
                </div>
                <span className="gtjw-saved-tag">Saved</span>
              </div>

              <div className="gtjw-saved-actions">
                <button
                  type="button"
                  className="gtjw-saved-primary"
                  disabled={savedResumeBusy}
                  onClick={useSavedResume}
                >
                  {savedResumeBusy ? "Loading resume..." : "Use Saved Resume"}
                </button>

                <button
                  type="button"
                  className="gtjw-saved-download"
                  disabled={savedResumeBusy}
                  onClick={downloadSavedResume}
                >
                  Download PDF
                </button>
              </div>

              <p className="gtjw-saved-caption">
                You can continue with this resume or upload a newer PDF below.
              </p>
            </section>
          )}

          {savedResumeError && (
            <p className="gtjw-saved-error" role="alert">
              {savedResumeError}
            </p>
          )}

<form className="gtjw-form" onSubmit={nextResume}>
                <label className="gtjw-upload">
                  <span>PDF Resume</span>
                  <input type="file" required accept=".pdf,application/pdf"
                    onChange={e=>setResume(e.target.files?.[0] || null)}/>
                  {resume && <small>Selected: {resume.name}</small>}
                </label>
                <button type="submit">Continue to Your Details</button>
              </form>
            </>
          )}

          {stage===2 && (
            <>
              <h3>Your details</h3>
              <p className="gtjw-sub">These details will be saved in your candidate profile.</p>
              <form className="gtjw-form" onSubmit={saveDetails}>
                <div className="gtjw-two">
                  <label>First name
                    <input required value={details.first}
                      onChange={e=>setDetails({...details,first:e.target.value})}/>
                  </label>
                  <label>Last name
                    <input required value={details.last}
                      onChange={e=>setDetails({...details,last:e.target.value})}/>
                  </label>
                </div>
                <label>Mobile number
                  <input type="tel" required value={details.phone}
                    placeholder="+91 9876543210"
                    onChange={e=>setDetails({...details,phone:e.target.value})}/>
                </label>
                
                
                <button type="submit" disabled={busy}>
                  {busy ? "Saving..." : "Save & Continue"}
                </button>
              </form>
            </>
          )}


          {stage===3 && (
            <>
              <h3>One membership. Apply for jobs all year.</h3>

              <div className="gtjw-payment-card">
                <div className="gtjw-payment-top">
                  <div>
                    <small>ANNUAL JOB PLATFORM ACCESS</small>
                    <div className="gtjw-price">
                      <strong>₹49</strong>
                      <span>/ year</span>
                    </div>
                  </div>
                  <span className="gtjw-payment-tag">
                    Annual membership
                  </span>
                </div>

                <p className="gtjw-payment-copy">
                  Your fee supports access to job applications,
                  application tracking and AI-assisted resume screening.
                  Pay once for your annual membership, not for every job.
                </p>

                <p className="gtjw-payment-disclaimer">
                  Membership does not guarantee an interview,
                  selection or job offer.
                </p>
              </div>

              {membership?.active ? (
                <>
                  <div className="gtjw-good">
                    ✓ Your membership is active. No payment required.
                  </div>

                  <button
                    type="button"
                    disabled={busy || !APPLICATIONS_ENABLED}
                    onClick={finishExistingMembership}
                  >
                    {busy
                      ? "Processing..."
                      : APPLICATIONS_ENABLED
                        ? "Complete My Application"
                        : "Applications Opening Soon"}
                  </button>
                </>
              ) : (
                <>
                  <button
                    type="button"
                    disabled={
                      busy ||
                      checkoutOpen ||
                      !CHECKOUT_ENABLED ||
                      !APPLICATIONS_ENABLED
                    }
                    onClick={beginMembershipPayment}
                  >
                    {busy
                      ? "Please wait..."
                      : CHECKOUT_ENABLED && APPLICATIONS_ENABLED
                        ? "Pay ₹49 & Complete Application"
                        : "Membership Payment Opening Soon"}
                  </button>

                  
                </>
              )}

              {paymentState === "submitting" && (
                <p className="gtjw-notice">
                  Payment verified. Submitting your resume...
                </p>
              )}

              {paymentState === "verifying" && (
                <p className="gtjw-notice">
                  Verifying your payment securely...
                </p>
              )}

              {!APPLICATIONS_ENABLED && (
                <p className="gtjw-notice">
                  Online applications are not open yet.
                  You will not be charged at this stage.
                </p>
              )}
            </>
          )}

          {stage===4 && (
            <div className="gtjw-success">
              {application || duplicateApplication ? (
                <>
                  <div className="gtjw-success-icon">✓</div>
                  <h3>
      {duplicateApplication
        ? "You've Already Applied for This Position"
        : "Application Submitted Successfully!"}
    </h3>
    <div className="gtjw-smooth-position">
      <span>Applied to</span>
      <strong>{job?.title || "Selected Position"}</strong>
      <small>{job?.company || ""}</small>
    </div>
                  <p>Your application ID</p>
                  <strong>{(application || duplicateApplication).application_id}</strong>
                  <p>
                    Your application is saved.
                    Track its progress in My Job Dashboard.
                  </p>
                  <GTJApplicationAutoReturn onClose={onClose} />
                  <button type="button" onClick={onClose}>
                    Return to Job Listings Now
                  </button>
                </>
              ) : (
                <p className="gtjw-error">
                  Application confirmation is unavailable.
                  Check My Job Dashboard before trying again.
                </p>
              )}
            </div>
          )}

          {notice && <p className="gtjw-notice">{notice}</p>}
          {error && <p className="gtjw-error" role="alert">{error}</p>}
        </div>
      </section>
    </div>
  );
}
